import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";

/**
 * Why does this class exists?
 * Check https://confluence.webapp.sdst.sbaintern.de/x/YjSvNQ
 * or https://confluence.webapp.sdst.sbaintern.de/pages/viewpage.action?pageId=900674658
 * or find OPOBD-99726
 * Reihenfolge entschieden 02.10.2025 in Teams Call mit
 * Bert Schindler, Tobias Helmlinger, Tobias Lang, Thomas Sumyk, Peter Meinl und Sascha Speckmaier
 */
export function DeeplinkGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const router = inject(Router);
    const url = state.url;
    const queryParams = route.queryParams as any;

    if (url.startsWith('/editor') && queryParams.entwurf_id) {
        return router.createUrlTree(['/entwurf/', queryParams.entwurf_id]);
    }

    if (url.startsWith('/editor') && queryParams.antwort_id) {
        return router.createUrlTree(['/antwort/', queryParams.antwort_id]);
    }

    if (url.startsWith('/editor') && queryParams.anliegen) {
        return router.createUrlTree(['/neu-vorbelegt'], {queryParams: queryParams});
    }

    if (url.startsWith('/editor')) {
        return router.createUrlTree(['/neu']);
    }

    if (url.startsWith('/#/ordner/')) {
        let newUrl = url.replace('/#', '').replace('nachrichten', 'nachricht').replace('?', '/');
        return router.createUrlTree([newUrl]);
    }

    // route to default landing page
    return router.createUrlTree(['/ordner/erhalten']);
}